import { useState } from "react";
import Modal from "react-responsive-modal";

const TrackTime = ({ open, setOpen }) => {
  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };
  const [isOn1, setIsOn1] = useState(false);

  const toggleSwitch1 = () => {
    setIsOn1(!isOn1);
  };

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  return (
    <div>

      <Modal open={open} onClose={onCloseModal} center>
        <div className="flex flex-row justify-between items-center space-y-0 pb-2">
          <h2 className="font-medium text-[24px] track-heading">
            Track In/Out Time
          </h2>
        </div>
        <div className="space-y-6">
          <div className="space-y-4">
            <div className="space-y-2">
              <div className="flex justify-between items-center border-[#dbdbdb] pb-[14px] border-b">
                <div>
                  <h3 className="text-xl track-heading">Track In & Out Time</h3>
                  <p className="text-muted-foreground staff-timeout">
                    Record both In & Out time for all staff
                  </p>
                </div>
                <div className="flex justify-between items-center p-4 cursor-pointer">
                  <div
                    className={`relative w-14 h-8 flex items-center rounded-full p-1 cursor-pointer ${isOn ? "bg-[#27004a]" : "bg-gray-300"
                      }`}
                    onClick={toggleSwitch}
                  >
                    <div
                      className={`bg-white w-6 h-6 rounded-full shadow-md transform duration-300 ease-in-out ${isOn ? "translate-x-6" : "translate-x-0"
                        }`}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-xl track-heading">
                    No attendance without punch-out
                  </h3>
                  <p className="text-muted-foreground staff-timeout">
                    Punch out is required to mark attendance
                  </p>
                </div>
                <div className="flex justify-between items-center p-4 cursor-pointer">
                  <div
                    className={`relative w-14 h-8 flex items-center rounded-full p-1 cursor-pointer ${isOn1 ? "bg-[#27004a]" : "bg-gray-300"
                      }`}
                    onClick={toggleSwitch1}
                  >
                    <div
                      className={`bg-white w-6 h-6 rounded-full shadow-md transform duration-300 ease-in-out ${isOn1 ? "translate-x-6" : "translate-x-0"
                        }`}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button className="allcrm-btn p-[10px] w-full text-lg" size="lg">
            Done
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default TrackTime;
